import React from "react";
import carepointImage1 from "../../assets/images/wellnesscarepoint/gal-3.png";
import carepointImage2 from "../../assets/images/wellnesscarepoint/gal-4.png";
import carepointImage3 from "../../assets/images/wellnesscarepoint/banner-vector-3.png";

import { motion } from "framer-motion";
import { fadeIn } from "../animation/Variants";

const WorkSchedulesContent = () => {
  const timeSchedule = [
    { id: 1, day: "Monday", starttime: "", endtime: "Closed" },
    { id: 2, day: "Tuesday", starttime: "08:30 AM", endtime: "05:30 PM" },
    { id: 3, day: "Wednesday", starttime: "08:30 AM", endtime: "05:30 PM" },
    { id: 4, day: "Thursday", starttime: "08:30 AM", endtime: "05:30 PM" },
    { id: 5, day: "Friday", starttime: "08:30 AM", endtime: "05:30 PM" },
    { id: 6, day: "Saturday", starttime: "08:30 AM", endtime: "05:30 PM" },
    { id: 7, day: "Sunday", starttime: "08:30 AM", endtime: "05:30 PM" },
  ];

  return (
    <motion.div
      variants={fadeIn("up", 0.2)}
      initial="hidden"
      whileInView={"show"}
      viewport={{ once: false, amount: 0.7 }}
      aria-hidden="true"
      className="flex flex-col mb-20 bg-customBrass-90 xl:flex-row gap-2 rounded-sm shadow-md  h-full"
    >
      <div className="flex bg-customMaroon-25 w-full  xl:w-1/2 rounded-l-sm text-white">
        <div className=" text-center px-5 py-5 ">
          <h4 className="title_DMSerifText-Regular  uppercase">
            Wellness carepoint
          </h4>
          <p className="description_AlegreyaSans-Light leading-tight">
            Physiotherapists use various techniques such as manual therapy, heat
            and cold therapy, and electrotherapy to alleviate pain and reduce
            inflammation.
          </p>

          <div className="flex flex-row mt-4 lg:gap-0 gap-2">
            <div className="w-full xl:w-1/2 ">
              <img
                src={carepointImage1}
                alt="image 2"
                className="h-full w-full object-cover lg:ml-2 rounded-sm"
              />
            </div>
            <div className="w-full xl:w-1/2">
              <img
                src={carepointImage2}
                alt="image 2"
                className="flex lg:mt-14 h-full w-full object-cover  rounded-sm"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="w-full  xl:w-1/2">
        <div className="flex justify-end">
          <img
            src={carepointImage3}
            alt="image 2"
            className="absolute z-10 object-cover"
          />
        </div>

        <div className="px-5 py-5">
          <h4 className="title_DMSerifText-Regular  uppercase text-customMaroon-25">
            Office Hours
          </h4>

          {timeSchedule.map((schedule) => (
            <div className="px-4 xl:px-20 py-3" key={schedule.id}>
              <div className="flex justify-between text-customMaroon-25 nav_logo_AlegreyaSans-Light">
                <p>{schedule.day}</p>
                <p>
                  {schedule.starttime} - {schedule.endtime}
                </p>
              </div>
              <hr className="border-dashed border-customMaroon-25 border-t-1.5 w-full" />
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default WorkSchedulesContent;
